import { Crm8Workflow } from "@/components/crm-demos/crm-8-workflow"
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_crm-demos/crm-8")({
  component: Crm8Page,
  head: () => ({ meta: [{ title: "CRM 8 · Workflow Board" }] }),
});

function Crm8Page() {
  return <Crm8Workflow />
}
